<template>
  <div class="drawer drawer-right" :class="{'drawer-open': visible}">
    <div class="drawer-mask" @click="onMaskClick"></div>
    <div class="drawer-content-wrapper" :style="{width: styleWidth+'px'}">
      <div class="drawer-content">
        <div class="drawer-wrapper-body">
          <div class="drawer-header">
            <div class="drawer-title">{{title}}</div>
          </div>
          <Icon @click="close" type="md-close" class="drawer-close" v-if="!maskClosable"></Icon>
          <div class="drawer-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'drawer',
  props: {
    title: {
      type: String,
      default: 'Create a title'
    },
    visible: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    styleWidth: {
      type: String,
      default: '256'
    },
    onClose: {
      type: Function
    }
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    onMaskClick () {
      if (!this.maskClosable) {
        return
      }
      this.close()
    },
    close () {
      if (this.visible !== undefined) {
        if (this.onClose) {
          this.onClose()
        }
      }
    }
  },
  components: {

  }
}
</script>

<style lang="scss">
.drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1000;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  > * {
    transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  }

  &-content-wrapper {
    position: absolute;
  }

  &-right {
    .drawer-content-wrapper,
    .drawer-content {
      height: 100%;
    }
  }

  &-right {
    .drawer {
      &-content-wrapper {
        right: 0;
        transform: translateX(100%);
      }
    }
    &.drawer-open {
      .drawer-content-wrapper {
        box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
        transform: translateX(0);
      }
    }
  }
  &.drawer-open {
    > * {
      pointer-events: auto;
    }
    .drawer {
      &-mask {
        opacity: 0.3;
      }
    }
  }

  &-title {
    margin: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }

  &-content {
    position: relative;
    background-color: #fff;
    border: 0;
    background-clip: padding-box;
    z-index: 1;
  }

  &-close {
    cursor: pointer;
    border: 0;
    background: transparent;
    position: absolute;
    right: 10px;
    top: 20px;
    z-index: 10;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    transition: color 0.3s;
    color: rgba(0, 0, 0, 0.45);
    outline: 0;
    padding: 0;

    &-x {
      display: block;
      font-style: normal;
      text-align: center;
      text-transform: none;
      text-rendering: auto;
      width: 56px;
      height: 56px;
      line-height: 56px;
      font-size: 16px;

      &:before {
        content: "\e633";
        display: block;
        font-family: "anticon" !important;
      }
    }

    &:focus,
    &:hover {
      color: #444;
      text-decoration: none;
    }
  }

  &-header {
    padding: 16px 24px;
    border-radius: 4px 4px 0 0;
    background: #fff;
    color: rgba(0, 0, 0, 0.65);
    border-bottom: 1px solid #e8e8e8;
  }

  &-body {
    padding: 24px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
  }

  &-mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.65);
    height: 100%;
    transition: opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    filter: alpha(opacity=50);
  }

  &-open {
    overflow: hidden;
  }

}

</style>
